import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './application-router.js';
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./timeline.css";
import "./star.css";
import "./wizard.css";
import './payment.css';
import './css/tables.css';
import './css/wizard.css';
import './css/datepicker.css';
import './select-csss.css';
import 'animate.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './css/react-bootstrap-table.css';
import './css/checkbox.css'
ReactDOM.render(
    <App />,
    document.getElementById('root'));
